import { Box, Flex, Heading } from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import Paginator from '../../components/Paginator';
import { createClient } from '../../services/chainClient';
import { RootState } from '../../store/reducers';
import WalletInfo from '../Wallet/WalletInfo';
import WalletPassphrase from '../Wallet/WalletPassphrase';
import WalletPasswordSetup from '../Wallet/WalletPasswordSetup';
import SetupInfluencerInfo from './pages/SetupInfluencerInfo';
import SetupInfluencerTwitter from './pages/SetupInfluencerTwitter';
import SetupInfluencerVerify from './pages/SetupInfluencerVerify';

enum Page {
  Info = 0,
  Twitter,
  WalletInfo,
  WalletPasswordSetup,
  WalletPassphrase,
  TwitterVerify,
}

const SetupInfluencer = () => {
  const [page, setPage] = useState(Page.Info);
  const handleNextPage = (page) => () => setPage(page);

  const [twitterInfo, setTwitterInfo] = useState<any | undefined>();

  const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);
  const [pubkey, setPubkey] = useState('');

  const history = useHistory();

  useEffect(() => {
    if (!mnemonic) return;
    (async () => {
      const bitcoin = createClient(mnemonic);
      const staticPubkeyAddress = await bitcoin.getMethod('getAddresses')(
        0,
        2,
        false
      );

      const staticPubkeyPair = await bitcoin.getMethod('keyPair')(
        staticPubkeyAddress[1].derivationPath
      );

      console.log(
        'Your static public key:',
        staticPubkeyPair.publicKey.toString('hex')
      );
      setPubkey(staticPubkeyPair.publicKey.toString('hex'));
    })();
  }, [mnemonic]);

  return (
    <>
      <Header h="5rem" borderRadius="0 0 2px 2px" />
      <Flex flexDir="column" alignItems="center" p={8}>
        <Paginator index={page}>
          <Heading size="lg" mb={8}>
            Setup your Influencer Page
          </Heading>
          <Heading size="lg" mb={8}>
            A good influencer page could use a few more details about you
          </Heading>
        </Paginator>

        <Box bg="white" w="1000px" borderRadius="8px" overflow="hidden">
          <Paginator index={page}>
            <SetupInfluencerInfo nextPage={handleNextPage(Page.Twitter)} />

            <SetupInfluencerTwitter
              onNext={() => {
                if (!twitterInfo) return;
                if (localStorage.getItem('encryptedMnemonic')) {
                  setPage(Page.TwitterVerify);
                } else {
                  setPage(Page.WalletInfo);
                }
              }}
              setTwitterInfo={setTwitterInfo}
              twitterInfo={twitterInfo}
            />
            <Box p={8}>
              <WalletInfo
                onBack={() => setPage(Page.Twitter)}
                onNext={() => setPage(Page.WalletPasswordSetup)}
              />
            </Box>
            <Box p={8}>
              <WalletPasswordSetup
                onBack={() => setPage(Page.Twitter)}
                onNext={() => setPage(Page.WalletPassphrase)}
              />
            </Box>

            <Box p={8}>
              <WalletPassphrase
                onBack={() => setPage(Page.WalletPasswordSetup)}
                onNext={() => setPage(Page.TwitterVerify)}
              />
            </Box>

            <SetupInfluencerVerify
              onNext={() => history.push('/dashboard')}
              twitterInfo={twitterInfo}
              pubkey={pubkey}
            />
          </Paginator>
        </Box>
      </Flex>
    </>
  );
};

export default SetupInfluencer;
